import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { ar, en } from './locales';

const options = {
  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  debug: false,

  lng: 'en',

  resources: {
    ar: {
      common: ar,
    },
    en: {
      common: en,
    },
  },

  fallbackLng: 'en',

  ns: ['common'],

  defaultNS: 'common',

  react: {
    // wait: false,
    // bindI18n: 'languageChanged loaded',
    // bindStore: 'added removed',
    // nsMode: 'default'
    bindI18n:'languageChanged',
    bindStore:'',
    transEmptyNodeValue:'',
    transSupportBasicHtmlNodes:true,
    transKeepBasicHtmlNodesFor:['br','strong','i'],
    useSuspense:true


  },
};

i18n
  .use(LanguageDetector)
  .init(options);

export default i18n;